import { ShowLessIcon, ShowMoreIcon } from '@kvdbil/components';
import React, { useState } from 'react';
import { Collapse } from 'react-collapse';
import styled from 'styled-components';
import { AlignIcon } from '~/App/shared/components/Layout/AlignIcon';
import { ProcessedAuction } from '~/App/shared/interfaces/ProcessedAuction';
import { useTranslation } from '~/Locale';
import BiddingHistory from './BiddingHistory';

const Container = styled.div`
  margin-top: 0.5rem;
`;

const ExpandLink = styled.div`
  font-weight: ${({ theme }) => theme.typography.fontBaseBoldWeight};
  font-size: 1em;
  text-align: center;
  color: ${({ theme }) => theme.colors.grayscaleToned.dark3};
  padding: 1.25em;
  cursor: pointer;
`;

const BiddingHistoryMain = styled.div<{ isOpen: boolean; isClosed: boolean }>`
  ${({ isOpen, isClosed }) => {
    if (isOpen) {
      return 'max-height: none;';
    } else if (isClosed) {
      return 'max-height: 0;';
    } else {
      return `
        max-height: 540px;
        @media screen and (max-width: 960px) {
          max-height: 415px;
        }
      `;
    }
  }};
  overflow: hidden;
  position: relative;
`;

export interface BiddingHistoryContainerProps {
  maxBidAmount: number;
  auction: ProcessedAuction;
  isClosed: boolean;
  isLeading: boolean;
  isReservationPriceReached: boolean;
}
export const BiddingHistoryContainer = ({
  auction,
  isClosed,
  isLeading,
  isReservationPriceReached,
  maxBidAmount
}: BiddingHistoryContainerProps) => {
  const { t } = useTranslation();
  const [isBiddingHistoryOpened, setIsBiddingHistoryOpened] = useState(false);

  const toggleHistoryOpen = () => {
    setIsBiddingHistoryOpened(prev => !prev);
  };

  return (
    <Container data-testid="bidding-history">
      <Collapse isOpened>
        <BiddingHistoryMain isClosed={isClosed} isOpen={isBiddingHistoryOpened}>
          <BiddingHistory
            isClosed={isClosed}
            auction={auction}
            isLeading={isLeading}
            maxBidAmount={maxBidAmount}
            myBidderAlias={auction.activeAuction?.myBidderAlias ?? ''}
            isReservationPriceReached={isReservationPriceReached}
          />
        </BiddingHistoryMain>
      </Collapse>

      {(isClosed || auction.bids.length > 3) && (
        <div>
          {!isBiddingHistoryOpened ? (
            <ExpandLink onClick={toggleHistoryOpen}>
              <AlignIcon left={0.5}>
                {isClosed
                  ? t('Bid history')
                  : t('Show more %1$s bids', auction.bids.length)}
                <ShowMoreIcon />
              </AlignIcon>
            </ExpandLink>
          ) : (
            <ExpandLink onClick={toggleHistoryOpen}>
              <AlignIcon left={0.5}>
                {isClosed ? t('Hide bid history') : t('Show less bids')}
                <ShowLessIcon />
              </AlignIcon>
            </ExpandLink>
          )}
        </div>
      )}
    </Container>
  );
};

export default BiddingHistoryContainer;
